<template>
  <div class="bg-white rounded">
    <div v-if="view === 'edit'" class="pt-3 mb-0">
      <div
        class="add_license d-flex justify-content-between align-items-center flex-wrap mb-2 px-3"
      >
        <div class="d-flex align-items-center">
          <div
            class="back-arrow cursor-pointer mr-3"
            :title="$t('dvir.back')"
            @click="backToTemplates"
          >
            <b-img :src="require('@/assets/back-arrow.svg')"></b-img>
          </div>
          <h3 class="font-weight-bold f-20 text-left mb-0 text-black">
            {{ editor.title }}
          </h3>
        </div>
        <div class="d-flex align-items-center flex-wrap">
          <b-button
            variant="outline-primary"
            class="mx-0 h-40px px-3 mr-2 d-flex align-items-center f-14"
            @click="setAllCardType('pass-fail')"
          >
            {{ $t("dvir.allPassFail") }}
          </b-button>
          <b-button
            variant="outline-primary"
            class="mx-0 h-40px px-3 mr-2 d-flex align-items-center f-14"
            @click="setAllCardType('photo')"
          >
            {{ $t("dvir.allPhoto") }}
          </b-button>
          <b-button
            variant="primary"
            class="export equipment d-flex justify-content-center align-items-center w-fit-content"
            @click="openAddItemModal"
          >
            <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
            <p class="mb-0 ml-2 text-white p-0">{{ $t("dvir.addItem") }}</p>
          </b-button>
        </div>
      </div>
      <b-row class="px-3 mb-2 mx-0">
        <b-col sm="6" md="4" class="text-left px-0 pr-sm-3">
          <label class="state pl-0">{{ $t("dvir.templateName") }}</label>
          <b-form-input
            v-model="editor.name"
            :placeholder="$t('dvir.templateNamePlaceholder')"
            class="unit"
          ></b-form-input>
        </b-col>
        <!-- <b-col sm="6" md="4" class="text-left px-0 mt-3 mt-sm-0">
          <label class="state pl-0">{{ $t("dvir.equipmentType") }}</label>
          <b-form-input :value="editor.equipment_type" class="unit" disabled></b-form-input>
        </b-col> -->
      </b-row>
      <div class="px-3 mb-2 d-flex justify-content-between align-items-center flex-wrap">
        <p class="f-12 text-grey mb-0 text-left">{{ $t("dvir.itemsHint") }}</p>
        <p class="f-12 text-grey mb-0">{{ $t("dvir.itemCount", { count: editor.items.length }) }}</p>
      </div>
      <b-table
        :sticky-header="'calc(100vh - 320px)'"
        ref="sortableTable"
        responsive
        :fields="itemFields"
        :items="editor.items"
        show-empty
        :empty-text="$t('dvir.noItems')"
      >
        <template #head(sort)="">
          <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2" cy="16" r="2" transform="rotate(-90 2 16)" fill="#C4C4C4" />
            <circle cx="2" cy="9" r="2" transform="rotate(-90 2 9)" fill="#C4C4C4" />
            <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#C4C4C4" />
          </svg>
        </template>
        <template #cell(sort)="">
          <svg class="sortable-handle" width="4" height="18" viewBox="0 0 4 18" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="2" cy="16" r="2" transform="rotate(-90 2 16)" fill="#C4C4C4" />
            <circle cx="2" cy="9" r="2" transform="rotate(-90 2 9)" fill="#C4C4C4" />
            <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#C4C4C4" />
          </svg>
        </template>
        <template #cell(name)="data">
          <b-form-input
            v-model="data.item.name"
            :placeholder="$t('dvir.itemTitle')"
            class="unit"
          ></b-form-input>
        </template>
        <template #cell(description)="data">
          <b-form-textarea
            v-model="data.item.description"
            class="f-12"
            :placeholder="$t('dvir.itemDescription')"
            rows="2"
            max-rows="4"
          ></b-form-textarea>
        </template>
        <template #cell(card_type)="data">
          <b-form-select class="f-12" v-model="data.item.card_type" :options="cardTypeOptions"></b-form-select>
        </template>
        <template #cell(action)="data">
          <svg
            @click="removeItem(data.item.id)"
            class="cursor-pointer"
            width="19"
            height="20"
            viewBox="0 0 19 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
              stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
              stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </template>
      </b-table>
      <b-modal
        id="modal-add-dvir-item"
        centered
        no-close-on-backdrop
        no-close-on-esc
        :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
        :body-class="'px-3 pt-2'"
        :header-class="'align-items-center'"
        scrollable
      >
        <template #modal-header="{ close }">
          <h5 class="modal-title">
            {{ $t("dvir.addItem") }}
          </h5>
          <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
            Close Modal
          </b-button>
        </template>
        <b-row>
          <b-col cols="12">
            <b-form-group :label="$t('dvir.itemTitleLabel')" class="text-left mb-0">
              <b-form-input
                v-model="newItem.name"
                :placeholder="$t('dvir.itemTitlePlaceholder')"
                class="unit"
              ></b-form-input>
              <p v-if="errors && errors.name" class="field-error">
                {{ errors.name[0] }}
              </p>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mt-3">
            <b-form-group :label="$t('dvir.description')" class="text-left mb-0">
              <b-form-textarea
                v-model="newItem.description"
                :placeholder="$t('dvir.itemDescriptionPlaceholder')"
                rows="2"
                max-rows="4"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mt-3">
            <b-form-group :label="$t('dvir.fieldType')" class="text-left mb-0">
              <b-form-select class="f-12" v-model="newItem.card_type" :options="cardTypeOptions"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <template #modal-footer>
          <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 mx-0">
            <b-button class="mx-0 h-40px w-100px m-0 mr-3" variant="secondary" @click="closeAddItemModal">
              {{ $t("dvir.cancel") }}
            </b-button>
            <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="saveNewItem">
              {{ $t("dvir.save") }}
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
    <div v-else class="table pt-3 mb-0">
      <div
        class="add_license d-flex justify-content-between align-items-center flex-wrap mb-2 px-3"
      >
        <h3 class="font-weight-bold f-20 text-left mb-0 text-black">
          {{ $t("dvir.title") }}
        </h3>
        <b-button
          @click="$bvModal.show('modal-add-dvir')"
          class="export equipment d-flex justify-content-center align-items-center w-fit-content"
          variant="primary"
        >
          <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
          <p class="mb-0 ml-2 text-white p-0">
            {{ $t("dvir.addTemplate") }}
          </p>
        </b-button>
      </div>
      <b-table
        :sticky-header="'calc(100vh - 273px)'"
        responsive
        :fields="translatedFields"
        :items="items"
        hover
        :per-page="perPage"
        :current-page="currentPage"
        show-empty
      >
      </b-table>
      <b-modal
        id="modal-add-dvir"
        centered
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        :body-class="'px-3 pt-2 pb-4 overflow-preview-auto'"
        :header-class="'align-items-center'"
        scrollable
      >
        <template #modal-header="{ close }">
          <h5 class="modal-title">
            {{ $t("dvir.addTemplate") }}
          </h5>
          <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
            Close Modal
          </b-button>
        </template>
        <p class="starter-intro text-left mb-3 mt-2">
          {{ $t("dvir.startingPointHint") }}
        </p>
        <div class="starter-grid">
          <div
            v-for="base in templateBases"
            :key="base.key"
            class="starter-card"
            @click="createFromBase(base)"
          >
            <div class="starter-icon" :style="{ background: base.style.bgColor }">
              <b-icon :icon="base.style.icon" :style="{ color: base.style.color }"></b-icon>
            </div>
            <div class="starter-name">{{ base.name }}</div>
            <div class="starter-sub">{{ base.description }}</div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "DVIR",
  data() {
    return {
      perPage: 50,
      currentPage: 1,
      items: [],
      view: "list",
      editor: { title: "", name: "", key: "", equipment_type: "", items: [] },
      newItem: { name: "", description: "", card_type: "pass-fail" },
      errors: {},
      templateBases: [],
      starterStyles: {
        vehicle: { icon: "truck", color: "#1a5fb4", bgColor: "#deeaf8" },
        trailer: { icon: "truck-flatbed", color: "#2d7d46", bgColor: "#d6f0df" },
        all: { icon: "list-check", color: "#7c3a05", bgColor: "#fef0d0" },
        blank: { icon: "plus", color: "#555555", bgColor: "#ebebeb" },
      },
      defaultStarterStyle: { icon: "file-earmark-text", color: "#555555", bgColor: "#ebebeb" },
    };
  },
  computed: {
    cardTypeOptions() {
      return [
        { value: "pass-fail", text: this.$t("dvir.ctPassFail") },
        { value: "pass-fail-photo", text: this.$t("dvir.ctPassFailPhoto") },
        { value: "photo", text: this.$t("dvir.ctPhoto") },
      ];
    },
    itemFields() {
      return [
        { key: "sort", label: "", thStyle: { minWidth: "20px", width: "20px" }, thClass: "font-table-weight-bold" },
        { key: "name", label: this.$t("dvir.itemTitle"), thClass: "font-table-weight-bold" },
        { key: "description", label: this.$t("dvir.description"), thClass: "font-table-weight-bold" },
        { key: "card_type", label: this.$t("dvir.fieldType"), thClass: "font-table-weight-bold" },
        { key: "action", label: this.$t("dvir.actionColumn"), thClass: "font-table-weight-bold" },
      ];
    },
    translatedFields() {
      return [
        { key: "name", label: this.$t("dvir.name") },
        { key: "equipment_type", label: this.$t("dvir.equipmentType") },
        { key: "description", label: this.$t("dvir.description") },
      ];
    },
  },
  methods: {
    ...mapActions(["getAllDVIRTemplates", "getDVIRTemplateStarters"]),
    createFromBase(base) {
      this.$bvModal.hide("modal-add-dvir");
      this.editor = {
        title: base.name,
        name: base.name,
        key: base.key,
        equipment_type: base.equipment_type,
        items: (base.definition || []).map((item) => ({
          ...item,
          card_type: item.card_type || "pass-fail",
        })),
      };
      this.view = "edit";
      this.$nextTick(() => this.initSortable());
    },
    backToTemplates() {
      this.view = "list";
    },
    openAddItemModal() {
      this.newItem = { name: "", description: "", card_type: "pass-fail" };
      this.errors = {};
      this.$bvModal.show("modal-add-dvir-item");
    },
    closeAddItemModal() {
      this.$bvModal.hide("modal-add-dvir-item");
    },
    saveNewItem() {
      if (!this.newItem.name.trim()) {
        this.errors = { name: [this.$t("dvir.itemTitleRequired")] };
        return;
      }
      const lastOrder = this.editor.items.length
        ? Math.max(...this.editor.items.map((item) => item.order || 0))
        : 0;
      const lastId = this.editor.items.length
        ? Math.max(...this.editor.items.map((item) => item.id || 0))
        : 0;
      this.editor.items.push({
        id: lastId + 1,
        name: this.newItem.name.trim(),
        description: this.newItem.description.trim(),
        category: "",
        card_type: this.newItem.card_type,
        order: lastOrder + 1,
      });
      this.closeAddItemModal();
    },
    setAllCardType(cardType) {
      this.editor.items.forEach((item) => {
        item.card_type = cardType;
      });
    },
    removeItem(id) {
      this.editor.items = this.editor.items.filter((item) => item.id !== id);
    },
    initSortable() {
      const tableBody = this.$refs.sortableTable.$el.querySelector('tbody');
      window.Sortable.create(tableBody, {
        animation: 150,
        handle: '.sortable-handle',
        onEnd: (evt) => {
          const items = [...this.editor.items];
          const [moved] = items.splice(evt.oldIndex, 1);
          items.splice(evt.newIndex, 0, moved);
          this.editor.items = items.map((item, index) => ({ ...item, order: index + 1 }));
        },
      });
    },
    async getDVIRData() {
      try {
        const data = await this.getAllDVIRTemplates();
        await this.getStarters();
        this.items = [];
        data.data.forEach((item) => {
            this.items.push({
              id: item.id,
              name: item.name,
              equipment_type: item.equipment_type,
              description: item.description,
        });
      })
      } catch (error) {
        console.error("Error fetching DVIR data:", error);
      }
    },
    async getStarters() {
      const data = await this.getDVIRTemplateStarters();
      const starters = Array.isArray(data) ? data : (data?.data || []);
      this.templateBases = starters.map((starter) => ({
        ...starter,
        style: this.starterStyles[starter.key] || this.defaultStarterStyle,
      }));
    },
  },
  async mounted() {
      await this.getDVIRData();
    }
};
</script>
<style scoped>
/* ── TEMPLATE EDITOR ── */
.back-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background-color: #f4f4f4;
  border: 1px solid #eaeaea;
  flex-shrink: 0;
}
.sortable-handle {
  cursor: grab;
}
.sortable-handle:active {
  cursor: grabbing;
}
.b-table >>> td textarea {
  min-width: 220px;
}

.starter-intro {
  font-size: 13px;
  color: #6c757d;
}
.starter-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
@media (max-width: 575px) {
  .starter-grid {
    grid-template-columns: 1fr;
  }
}
.starter-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 1rem;
  text-align: left;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}
.starter-card:hover {
  border-color: #1a5fb4;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}
.starter-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  font-size: 18px;
}
.starter-name {
  font-size: 14px;
  font-weight: 600;
  color: #212529;
}
.starter-sub {
  font-size: 12px;
  line-height: 1.4;
  color: #6c757d;
}
</style>
